import React from "react";
import html from "../../assets/html-1.svg";
import css from "../../assets/css-3.svg";
import javascript from "../../assets/javascript-1.svg";
import materialUi from "../../assets/material-ui-1.svg";
import react from "../../assets/react-2.svg";
import redux from "../../assets/redux.svg";
import typescript from "../../assets/typescript-2.svg";
import foto from "../../assets/foto.jpg";
import {
  DevContainer,
  HomeContainer,
  IgorContainer,
  TechContainer,
  TextIgorContainer,
} from "./style";
import { useState } from "react";
export const Home = () => {
  const [develop, setDevelop] = useState("Font-End");
  const [active, setActive] = useState(null);

  const handleDevelop = () => {
    setInterval(() => {
      setActive(true);
      if (!active) {
        setDevelop("Back-End");
      } else {
        setDevelop("FullStack");
      }
    }, 4000);
  };

  handleDevelop();
  return (
    <HomeContainer>
      <IgorContainer>
        <img src={foto} alt="Igor Garcia" />
      </IgorContainer>
      <TextIgorContainer>
        <h1>Igor Garcia</h1>
      </TextIgorContainer>
      <DevContainer>
        <h2>Desenvolvedor</h2>
        <h2>{develop}</h2>
      </DevContainer>
      <TechContainer>
        <div>
          <img src={html} alt="HTML 5" />
          <img src={css} alt="CSS 3" />
          <img src={javascript} alt="Javascript" />
          <img src={react} alt="React" />
          <img src={materialUi} alt="Material UI" />
          <img src={redux} alt="Redux" />
          <img src={typescript} alt="Typescript" />
        </div>
      </TechContainer>
    </HomeContainer>
  );
};
